

import React, {  useEffect } from "react";

const BackgroundCanvas = ({ canvas_ref, background_url }) => {

    useEffect(() => {

        if (canvas_ref.current && background_url) {

            let imageWidth, imageHeight;
            const image = new Image();
            image.src = background_url

            const canvas = canvas_ref.current;
            const context = canvas.getContext("2d");
            const aspectRatio = 1920 / 1080;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const windowAspectRatio = windowWidth / windowHeight;

            if (windowAspectRatio < aspectRatio) {
                imageWidth = windowWidth;
                imageHeight = windowWidth / aspectRatio;
            } else {
                imageWidth = windowHeight * aspectRatio;
                imageHeight = windowHeight;
            }
            canvas.width = imageWidth
            canvas.height = imageHeight

            image.addEventListener("load", function () {
                context.drawImage(image, 0, 0, imageWidth, imageHeight);
            });

            window.addEventListener("resize", function () {

                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;
                const windowAspectRatio = windowWidth / windowHeight;

                if (windowAspectRatio < aspectRatio) {
                    imageWidth = windowWidth;
                    imageHeight = windowWidth / aspectRatio;
                } else {
                    imageWidth = windowHeight * aspectRatio;
                    imageHeight = windowHeight;
                }
                canvas.width = imageWidth
                canvas.height = imageHeight
                context.drawImage(image, 0, 0, imageWidth, imageHeight);
            });

            return () => {
                window.removeEventListener("resize", function () { });
            };

        }
    }, [canvas_ref.current, background_url]);

    return (
        <canvas ref={canvas_ref} id="image-canvas"></canvas>
    );
};

export default BackgroundCanvas;
